class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;
    
    // Check if this is the last footer accordion
    this.isLastAccordion = this.checkIfLastAccordion();
    
    // Create media query for small screens (less than 500px)
    this.mqlSmallScreen = window.matchMedia('(max-width: 499px)');
    this.handleSmallScreenChange = this.handleSmallScreenChange.bind(this);
    this.mqlSmallScreen.addEventListener('change', this.handleSmallScreenChange);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchTablet', this.close.bind(this));
    document.addEventListener('unmatchTablet', this.open.bind(this));
    
    // Initial check for small screens
    this.handleSmallScreenChange(this.mqlSmallScreen);

    if (!theme.config.mqlTablet || this.summaryIsEmpty || (this.isLastAccordion && this.mqlSmallScreen.matches)) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    }
    else {
      if (this.dataset.open == undefined) this.detailsContainer.removeAttribute('open');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    // Keep last accordion open on small screens
    if ((this.isLastAccordion && this.mqlSmallScreen.matches) || !theme.config.mqlTablet || this.summaryIsEmpty) {
      return;
    }
    this.detailsContainer.removeAttribute('open');
  }
  
  handleSmallScreenChange(mediaQuery) {
    if (mediaQuery.matches && this.isLastAccordion) {
      // Small screen and last accordion - ensure it's open
      this.open();
    } else if (!mediaQuery.matches && this.isLastAccordion && theme.config.mqlTablet && !this.summaryIsEmpty) {
      // Not small screen anymore - follow regular tablet rules
      if (this.dataset.open == undefined) {
        this.close();
      }
    }
  }
  
  checkIfLastAccordion() {
    // Get all footer accordions and check if this is the last one
    const allAccordions = Array.from(document.querySelectorAll('footer-accordion'));
    return allAccordions[allAccordions.length - 1] === this;
  }
}

customElements.define('footer-accordion', FooterAccordion);